import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import { TagsInput } from "react-tag-input-component";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import Dropdown from "react-bootstrap/Dropdown";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { ModalAllder } from "layouts/ModalAllder";
import LoadPR from "layouts/LoadDucument/PurchaseRequisition";
import { NumericFormat } from "react-number-format";
import { useReactToPrint } from "react-to-print";
import { ProductHistory } from "layouts/ProductHistory";
import { ModalProductReceive } from "layouts/ModalproductReceive";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import DatePicker from "react-datepicker";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstDiscountType } from "../../redux/handlers/master/getAllMstDiscountType.handler";
import { initState } from "mocks/grData";
import moment from "moment";
import { getAllSupplierInformation } from "../../redux/handlers/logic/getAllSupplierInformation.handler";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import { base64ToBlob, getEmpFullNameTHByEmpData, isReadyToPrint, mappingOptionNewItemPrCol } from "utils/HelperFunction";
import { clearCreateNewPurchaseReq } from "../../redux/handlers/logic/createNewPurchaseReq.handler";
import dayjs from "dayjs";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { getAllMstNewItemPrCol } from "../../redux/handlers/master/getAllMstNewItemPrCol.handler";
import { LoadDocument } from "layouts/LoadDucuments";
import { ProductSelect } from "layouts/ProductSelect";
import { ProductTableSort } from "layouts/ProductTableSort";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import Grstatus from "fragments/GRStatus";
import { getNewPoSplitById } from "../../redux/handlers/logic/getNewPoSplitById.handler";
import { genNewGrDocNumber } from "../../redux/handlers/logic/genNewGrDocNumber.handler";
import { clearCreateNewGr, createNewGr } from "../../redux/handlers/logic/createNewGr.handler";
import { checkDateDifference, grVerifyCases, isFinanVerify, mappingGr, mappingLotGrs } from "utils/HelperGrFunction";
import { getNewGrById } from "../../redux/handlers/logic/getNewGrById.handler";
import { clearUpdateNewGr, updateNewGr } from "../../redux/handlers/logic/updateNewGr.handler";
import DocStatus from "layouts/DocStatus";
import { mappingPoSplit } from "utils/HelperPoSplitFunction";
import { Checkbox } from "@mui/material";
import { GRPrint } from "layouts/PrintGR";
import { ProductTableFilterDisplay } from "layouts/ProductTableFilterDisplay";
import { getProductInit } from "utils/HelperProduct";
export function GoodsReceipt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useParams = useParams(), action = _useParams.action, dataID = _useParams.dataID;
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState1[0], setSumproductPrice = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState2[0], setSumproductNoVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState3[0], setSumproductZeroVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState4[0], setSumproductSevenVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState5[0], setSumproductBeforeVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumProductReceivedQuantity = _useState6[0], setSumProductReceivedQuantity = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumProductBalanceQuantity = _useState7[0], setSumProductBalanceQuantity = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), sumProductReceiveQuantity = _useState8[0], setSumProductReceiveQuantity = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), updateDocIds = _useState9[0], setUpdateDocIds = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState10[0], setColumnsort = _useState10[1];
    var schema = yup.object().shape({
        dim_mst_price_category_id: yup.string().required(),
        dim_supplier_information_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required(),
        doc_receive_date: yup.date().required(),
        doc_receive_time: yup.string().required(),
        delivery_date: yup.string().required(),
        delivery_time: yup.string().required(),
        dim_warehouse_id: yup.string().when("is_one_receiving_point", {
            is: function(v) {
                return v == 1;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        dim_new_gr_items: yup.array().of(yup.object().shape({
            dim_warehouse_id: yup.string().required("Warehouse ID is required.")
        })),
        not_approve_reason: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        dim_mst_new_status_id: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        refer: yup.string().required()
    });
    var _useState11 = _sliced_to_array(useState(false), 2), formdisabled = _useState11[0], setFormdisabled = _useState11[1];
    var _useState12 = _sliced_to_array(useState(initState), 2), formdata = _useState12[0], setFormdata = _useState12[1];
    var _useState13 = _sliced_to_array(useState(), 2), docGrNumber = _useState13[0], setDocGrNumber = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), docDate = _useState14[0], setDocDate = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        id: "",
        dimGroupOfSupplierCode: "",
        full_supplier_name: "-",
        initials: "-",
        company_branch_code: "",
        company_branch_name: "",
        full_supplier_address_name: "-",
        company_phone_number: "-"
    }), 2), pdata = _useState15[0], setPdata = _useState15[1];
    var _useState16 = _sliced_to_array(useState(1), 2), tab = _useState16[0], setTab = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), tagselected = _useState17[0], setTagSelected = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), attachments = _useState18[0], setAttachments = _useState18[1];
    var handlePreviewFile = function(e, itemIndex) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachments(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
                e.target.value = "";
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var _useState19 = _sliced_to_array(useState({
        QtyNotMatch: false,
        QtyNotMatchAccept: false,
        InputInvalid: false,
        InputInvalidAccept: false
    }), 2), alert = _useState19[0], setAlert = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState20[0], setModalSuccess = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success2"
    }), 2), modalApproveRequestSuccess = _useState21[0], setModalApproveRequestSuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState22[0], setModalSaveSuccess = _useState22[1];
    var _useState23 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalApproveSuccess = _useState23[0], setModalApproveSuccess = _useState23[1];
    var _useState24 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState24[0], setModalNotApprove = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState25[0], setModalAlert = _useState25[1];
    var _useState26 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 500,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "product-verify"
    }), 2), modalVerifyInformation = _useState26[0], setModalVerifyInformation = _useState26[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getAllMstNewItemPrCol());
    };
    var loadAllResources = function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(genNewGrDocNumber({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState27 = _sliced_to_array(useState([]), 2), optionsMstPaymentType = _useState27[0], setOptionsMstPaymentType = _useState27[1];
    var _useState28 = _sliced_to_array(useState([]), 2), optionsMstPriceCategory = _useState28[0], setOptionsMstPriceCategory = _useState28[1];
    var _useState29 = _sliced_to_array(useState([]), 2), optionsMstDiscountType = _useState29[0], setOptionsMstDiscountType = _useState29[1];
    var _useState30 = _sliced_to_array(useState([]), 2), optionsMstVat = _useState30[0], setOptionsMstVat = _useState30[1];
    var _useState31 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState31[0], setOptionsWarehouse = _useState31[1];
    var _useState32 = _sliced_to_array(useState([]), 2), optionNewItemPrCol = _useState32[0], setOptionNewItemPrCol = _useState32[1];
    var _useState33 = _sliced_to_array(useState(), 2), userInfo = _useState33[0], setUserInfo = _useState33[1];
    var getAllMstPaymentTypeReducer = useAppSelector(function(state) {
        return state.getAllMstPaymentTypeReducer;
    });
    var getAllMstPriceCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstPriceCategoryReducer;
    });
    var getAllMstDiscountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstDiscountTypeReducer;
    });
    var getAllMstVatReducer = useAppSelector(function(state) {
        return state.getAllMstVatReducer;
    });
    var getAllWarehouseReducer = useAppSelector(function(state) {
        return state.getAllWarehouseReducer;
    });
    var getAllMstNewItemPrColReducer = useAppSelector(function(state) {
        return state.getAllMstNewItemPrColReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    useEffect(function() {
        loadAllMsts();
        loadAllResources();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPaymentTypeReducer.isFetching || getAllMstPriceCategoryReducer.isFetching || getAllMstDiscountTypeReducer.isFetching || getAllMstVatReducer.isFetching || getUserInfoReducer.isFetching);
        if (getUserInfoReducer.data) {
            setUserInfo(getUserInfoReducer.data.data);
        }
        if (getAllMstPaymentTypeReducer.data) {
            setOptionsMstPaymentType(getAllMstPaymentTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstPriceCategoryReducer.data) {
            setOptionsMstPriceCategory(getAllMstPriceCategoryReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstDiscountTypeReducer.data) {
            setOptionsMstDiscountType(getAllMstDiscountTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstVatReducer.data) {
            setOptionsMstVat(getAllMstVatReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }));
        }
        if (getAllWarehouseReducer.data) {
            setOptionsWarehouse(getAllWarehouseReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstNewItemPrColReducer.data) {
            var optionsMap = mappingOptionNewItemPrCol(getAllMstNewItemPrColReducer.data.data);
            setOptionNewItemPrCol(optionsMap);
        }
    }, [
        getAllMstPaymentTypeReducer,
        getAllMstPriceCategoryReducer,
        getAllMstDiscountTypeReducer,
        getAllMstVatReducer,
        getAllWarehouseReducer,
        getAllMstNewItemPrColReducer,
        getUserInfoReducer
    ]);
    var genNewGrDocNumberReducer = useAppSelector(function(state) {
        return state.genNewGrDocNumberReducer;
    });
    var _useState34 = _sliced_to_array(useState([]), 2), supplierInfos = _useState34[0], setSupplierInfos = _useState34[1];
    var getAllSupplierInformationReducer = useAppSelector(function(state) {
        return state.getAllSupplierInformationReducer;
    });
    useEffect(function() {
        setIsLoading(genNewGrDocNumberReducer.isFetching || getAllSupplierInformationReducer.isFetching);
        if (genNewGrDocNumberReducer.data && action === "create") {
            setDocGrNumber(genNewGrDocNumberReducer.data.data);
        }
        if (getAllSupplierInformationReducer.data) {
            setSupplierInfos(getAllSupplierInformationReducer.data.data);
        }
    }, [
        genNewGrDocNumberReducer,
        getAllSupplierInformationReducer
    ]);
    var createNewPurchaseReqReducer = useAppSelector(function(state) {
        return state.createNewPurchaseReqReducer;
    });
    useEffect(function() {
        setIsLoading(createNewPurchaseReqReducer.isFetching);
        if (createNewPurchaseReqReducer.data && !createNewPurchaseReqReducer.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setFormdisabled(true);
            dispatch(clearCreateNewPurchaseReq());
            var createdData = createNewPurchaseReqReducer.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            // if (id) {
            //   navigate(`/purchase/requisition/edit/${id}`);
            // } else {
            //   navigate("/purchase/requisition");
            // }
            navigate("/goods-receipt");
        }
    }, [
        createNewPurchaseReqReducer
    ]);
    var updateNewGrReducer = useAppSelector(function(state) {
        return state.updateNewGrReducer;
    });
    useEffect(function() {
        setIsLoading(updateNewGrReducer.isFetching);
        if (updateNewGrReducer.data && !updateNewGrReducer.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            getNewGrData();
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setTab(1);
            dispatch(clearUpdateNewGr());
            navigate("/goods-receipt");
        }
    }, [
        updateNewGrReducer
    ]);
    var getNewPoSplitByIdReducer = useAppSelector(function(state) {
        return state.getNewPoSplitByIdReducer;
    });
    var getPoSplitData = function() {
        dispatch(getNewPoSplitById(dataID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getNewGrByIdReducer = useAppSelector(function(state) {
        return state.getNewGrByIdReducer;
    });
    var getNewGrData = function() {
        dispatch(getNewGrById(dataID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState35 = _sliced_to_array(useState("สร้างใบรับสินค้า"), 2), headerName = _useState35[0], setheaderName = _useState35[1];
    var _useState36 = _sliced_to_array(useState({
        isCreate: true,
        isEdit: false
    }), 2), caseController = _useState36[0], setCaseController = _useState36[1];
    useEffect(function() {
        if (dataID && action === "create") {
            getPoSplitData();
            setCaseController(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isCreate: true,
                    isEdit: false
                });
            });
            setheaderName("สร้างใบรับสินค้า");
        } else if (dataID && action === "edit") {
            getNewGrData();
            setCaseController(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    isCreate: false,
                    isEdit: true
                });
            });
            setheaderName("แก้ไขใบรับสินค้า");
        }
    }, [
        dataID,
        action
    ]);
    useEffect(function() {
        setIsLoading(getNewGrByIdReducer.isFetching);
        if (getNewGrByIdReducer.data && !getNewGrByIdReducer.isError && dataID) {
            var grData = getNewGrByIdReducer.data.data;
            if (!grData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingGr({
                grData: grData,
                action: action,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        getNewGrByIdReducer
    ]);
    useEffect(function() {
        setIsLoading(getNewPoSplitByIdReducer.isFetching);
        if (getNewPoSplitByIdReducer.data && !getNewPoSplitByIdReducer.isError && dataID) {
            var poSplitData = getNewPoSplitByIdReducer.data.data;
            if (!poSplitData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingPoSplit({
                poSplitData: poSplitData,
                action: action,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        getNewPoSplitByIdReducer
    ]);
    var createNewGrReducer = useAppSelector(function(state) {
        return state.createNewGrReducer;
    });
    useEffect(function() {
        setIsLoading(createNewGrReducer.isFetching);
        if (createNewGrReducer.data && !createNewGrReducer.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setFormdisabled(true);
            dispatch(clearCreateNewGr());
            var createdData = createNewGrReducer.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            // if (id) {
            //   navigate(`/goods-receipt/edit/${id}`);
            // } else {
            //   navigate("/purchase/orders");
            // }
            navigate("/goods-receipt");
        }
    }, [
        createNewGrReducer
    ]);
    // const updateNewPurchaseReqReducer = useAppSelector(
    //   (state) => state.updateNewPurchaseReqReducer
    // );
    // useEffect(() => {
    //   setIsLoading(updateNewPurchaseReqReducer.isFetching);
    //   if (
    //     updateNewPurchaseReqReducer.data &&
    //     !updateNewPurchaseReqReducer.isError
    //   ) {
    //     setModalNotApprove((prev) => ({ ...prev, open: false }));
    //     // getData();
    //     setModalSuccess((prev) => ({ ...prev, open: true }));
    //     dispatch(clearUpdateNewPurchaseReq());
    //   }
    // }, [updateNewPurchaseReqReducer]);
    useEffect(function() {
        if (dataID) {
            var deleteCandidateDocIds = formdata.dimDocFilePr ? formdata.dimDocFilePr.map(function(item) {
                return item.id;
            }) : [];
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            var allDocIds = _to_consumable_array(deleteDocIds);
            console.log("All Doc IDs to update or delete:", allDocIds);
            setUpdateDocIds(allDocIds);
        }
    }, [
        dataID,
        attachments
    ]);
    var componentRef = useRef();
    var componentOnlyReceiveRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var handleOnlyReceivePrint = useReactToPrint({
        content: function() {
            return componentOnlyReceiveRef.current;
        }
    });
    var _useState37 = _sliced_to_array(useState(true), 2), Collapse = _useState37[0], setCollapse = _useState37[1];
    var _useState38 = _sliced_to_array(useState([]), 2), productReceive = _useState38[0], setProductReceive = _useState38[1];
    var _useState39 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-receive"
    }), 2), modalProductReceive = _useState39[0], setModalProductReceive = _useState39[1];
    var _useState40 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 360,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmCancel = _useState40[0], setModalConfirmCancel = _useState40[1];
    var _useState41 = _sliced_to_array(useState({
        onlyReceiveProduct: {
            isActive: false,
            name: "แสดงเฉพาะสินค้ารับแล้ว"
        }
    }), 2), filterDisplay = _useState41[0], setFilterDisplay = _useState41[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบรับสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var _loop = function(key) {
                        if (Object.hasOwnProperty.call(values, key)) {
                            var value = values[key];
                            if (key === "dim_employee_attached_doc" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "update_doc_types" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "update_doc_ids" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "tag_grs" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "dim_new_gr_items" && value) {
                                // console.log(value);
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "doc_files" && Array.isArray(value)) {
                                value.forEach(function(base64String, index) {
                                    if (base64String) {
                                        var blob = base64ToBlob(base64String);
                                        formdataPayload.append("".concat(key), blob, "document_".concat(index, ".pdf"));
                                    }
                                });
                            } else if (Array.isArray(value)) {
                                value.forEach(function(item) {
                                    return formdataPayload.append(key, item);
                                });
                            } else if (value !== undefined) {
                                formdataPayload.append(key, value);
                            }
                        }
                    };
                    var formdataPayload = new FormData();
                    for(var key in values)_loop(key);
                    if (dataID && action === "create") {
                        dispatch(createNewGr(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else if (dataID && action === "edit") {
                        dispatch(updateNewGr(dataID, formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) /*#__PURE__*/ {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, setErrors = param.setErrors, setTouched = param.setTouched, isInvalid = param.isInvalid, isValid = param.isValid;
                    var _values_dimMstNewStatus, _values_dimMstNewStatus1;
                    var _values_doc_number;
                    return _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            var product = productRow.filter(function(prev) {
                                return prev.productCode !== "";
                            });
                            if (product && product.length > 0 && sumProductReceiveQuantity > 0) {
                                var newItems = [];
                                if (action === "create") {
                                    newItems = product.map(function(v) {
                                        return {
                                            dim_product_price_id: v.productID,
                                            dim_new_po_split_item_id: v.dim_new_po_split_item_id,
                                            dim_warehouse_id: v.warehouseID,
                                            po_split_quantity: v.productQty,
                                            receive_quantity: v.productReceiveQuantity,
                                            unit_price: v.productPrice,
                                            unit_id: v.productUnitID,
                                            ratio_unit: v.productRatioUnit,
                                            container: v.productContainer,
                                            dim_mst_discount_type_id: v.discountType,
                                            discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
                                            dim_mst_vat_id: v.dim_mst_vat_id,
                                            remark: v.note,
                                            dim_lot_grs: mappingLotGrs(v.receivelist)
                                        };
                                    });
                                }
                                schema.validate(action === "create" ? _object_spread_props(_object_spread({}, values), {
                                    dim_new_gr_items: newItems
                                }) : values, {
                                    abortEarly: false
                                }).then(function() {
                                    setFieldValue("doc_files", attachments.map(function(v) {
                                        return v.docFileData;
                                    }));
                                    if (action === "create") {
                                        setFieldValue("dim_new_gr_items", newItems);
                                    }
                                    setFieldValue("tag_grs", tagselected);
                                    if (dataID) {
                                        setFieldValue("update_doc_ids", updateDocIds);
                                    }
                                    handleSubmit();
                                }).catch(function(err) {
                                    var validationErrors = {};
                                    err.inner.forEach(function(error) {
                                        validationErrors[error.path] = error.message;
                                    });
                                    // Set validation errors to Formik
                                    setErrors(validationErrors);
                                    // Optionally mark fields as touched
                                    err.inner.forEach(function(error) {
                                        setTouched(function(prevTouched) {
                                            return _object_spread_props(_object_spread({}, prevTouched), _define_property({}, error.path, true));
                                        });
                                    });
                                });
                            } else {
                                setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3 pagezoom",
                                        style: {
                                            maxWidth: "700px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Steps, {
                                            grstatus: dataID && values.dimMstNewStatus ? (_values_dimMstNewStatus = values.dimMstNewStatus) === null || _values_dimMstNewStatus === void 0 ? void 0 : _values_dimMstNewStatus.id : 0
                                        })
                                    }),
                                    action === "edit" && dataID && values.canceledByEmp && /*#__PURE__*/ _jsxs("div", {
                                        className: "cancel-warn pagezoom mb-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/images/icon-warn-red.png"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16",
                                                children: "".concat(moment(values.canceled_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.canceledByEmp), " “").concat(values.not_approve_reason, "”")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        style: {
                                            minWidth: "1000px"
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                id: "",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "pt-3 px-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "row row gx-xl-4",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-12",
                                                                    children: dataID && values.dimMstNewStatus && /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end align-items-center h-100",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx(Grstatus, {
                                                                                statusID: values.dimMstNewStatus.id,
                                                                                statusName: values.dimMstNewStatus.name,
                                                                                finanStatusID: values.financialStatusID
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "เลขที่ใบรับสินค้า",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "doc_number",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: (_values_doc_number = values.doc_number) !== null && _values_doc_number !== void 0 ? _values_doc_number : docGrNumber,
                                                                                    onChange: handleChange,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "   mt-[12px]",
                                                                            children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                dateAdapter: AdapterDayjs,
                                                                                className: "h-[40px] ",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "flex",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "grow  pe-3 relative",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                                    className: "absolute top-[-50px] text-[#d32f2f] text-[15px]",
                                                                                                    children: checkDateDifference(values.doc_receive_date)
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                                                                    format: "DD/MM/YYYY",
                                                                                                    slotProps: {
                                                                                                        textField: {
                                                                                                            InputLabelProps: {
                                                                                                                shrink: true
                                                                                                            },
                                                                                                            error: !!errors.doc_receive_date
                                                                                                        }
                                                                                                    },
                                                                                                    label: "วันที่รับสินค้า",
                                                                                                    className: "h-[40px] w-full ",
                                                                                                    sx: {
                                                                                                        ".MuiInputBase-formControl": {
                                                                                                            height: "53px",
                                                                                                            borderRadius: "8px"
                                                                                                        },
                                                                                                        ".MuiFormLabel-root": {
                                                                                                            fontFamily: "Sarabun"
                                                                                                        },
                                                                                                        ".MuiOutlinedInput-notchedOutline": {
                                                                                                            border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                                        }
                                                                                                    },
                                                                                                    name: "doc_receive_date",
                                                                                                    value: values.doc_receive_date ? dayjs(values.doc_receive_date) : null,
                                                                                                    onChange: function(date) {
                                                                                                        var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                                        setFieldValue("doc_receive_date", formattedDate);
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "w-[120px]",
                                                                                            children: /*#__PURE__*/ _jsx(TimePicker, {
                                                                                                format: "HH:mm",
                                                                                                ampm: false,
                                                                                                label: "เวลาที่รับสินค้า",
                                                                                                slotProps: {
                                                                                                    textField: {
                                                                                                        InputLabelProps: {
                                                                                                            shrink: true
                                                                                                        },
                                                                                                        error: !!errors.doc_receive_time
                                                                                                    }
                                                                                                },
                                                                                                sx: {
                                                                                                    ".MuiInputBase-formControl": {
                                                                                                        height: "53px",
                                                                                                        borderRadius: "8px"
                                                                                                    },
                                                                                                    ".MuiFormLabel-root": {
                                                                                                        fontFamily: "Sarabun"
                                                                                                    },
                                                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                                    }
                                                                                                },
                                                                                                name: "doc_receive_time",
                                                                                                value: values.doc_receive_date && values.doc_receive_time ? dayjs("".concat(moment(new Date()).format("YYYY-MM-DD"), "T").concat(values.doc_receive_time)) : null,
                                                                                                onChange: function(time) {
                                                                                                    var formattedTime = moment(time.$d).format("HH:mm");
                                                                                                    setFieldValue("doc_receive_time", formattedTime);
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "อ้างอิงจากระบบ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.po_split_refer,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ผู้จัดทำเอกสาร",
                                                                                        " "
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "ผู้จัดทำเอกสาร",
                                                                                    value: getEmpFullNameTHByEmpData(dataID && action === "edit" ? values.createdNewGrEmp : userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ผู้จัดจำหน่าย"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "full_supplier_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.full_supplier_name,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.full_supplier_name,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "คลังสินค้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "dim_warehouse_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.dim_warehouse_name,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.dim_warehouse_name,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "   mt-[12px]",
                                                                            children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                dateAdapter: AdapterDayjs,
                                                                                className: "h-[40px] ",
                                                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    format: "DD/MM/YYYY",
                                                                                    // slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                                                                                    label: "วันที่จัดส่ง",
                                                                                    className: "h-[40px] w-full ",
                                                                                    sx: {
                                                                                        ".MuiInputBase-formControl": {
                                                                                            height: "53px",
                                                                                            borderRadius: "8px"
                                                                                        },
                                                                                        ".MuiFormLabel-root": {
                                                                                            fontFamily: "Sarabun"
                                                                                        },
                                                                                        ".Mui-disabled": {
                                                                                            background: "#F8F8F9"
                                                                                        },
                                                                                        ".MuiOutlinedInput-notchedOutline": {
                                                                                            border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                        }
                                                                                    },
                                                                                    name: "delivery_date",
                                                                                    value: dayjs(values.delivery_date),
                                                                                    onChange: function(date) {
                                                                                        setFieldValue("delivery_date", moment(date).format("YYYY-MM-DD"));
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "เอกสารอ้างอิง *"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "refer",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.refer,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.refer
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "บริษัท"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: pdata.full_supplier_name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "ที่อยู่"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.full_supplier_address_name
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "เบอร์โทร"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.company_phone_number
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "pb-4 pt-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold fs-18 mb-2",
                                                                                    children: "ชื่อย่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        children: pdata.initials
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx("button", {
                                            type: "button",
                                            className: "btn btn-st-3 me-3",
                                            style: tab != 1 ? {
                                                background: "transparent",
                                                border: 0,
                                                color: "#9C9C9C"
                                            } : {},
                                            children: "ข้อมูลสินค้า"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        sumProductReceiveQuantity: sumProductReceiveQuantity,
                                        setSumProductReceiveQuantity: setSumProductReceiveQuantity,
                                        optionsWarehouse: optionsWarehouse,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsMstVat: optionsMstVat,
                                        optionNewItemPrCol: optionNewItemPrCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        setProductReceive: setProductReceive,
                                        setModalProductReceive: setModalProductReceive,
                                        caseController: caseController,
                                        sumProductReceivedQuantity: sumProductReceivedQuantity,
                                        setSumProductReceivedQuantity: setSumProductReceivedQuantity,
                                        sumProductBalanceQuantity: sumProductBalanceQuantity,
                                        setSumProductBalanceQuantity: setSumProductBalanceQuantity,
                                        filterDisplay: filterDisplay,
                                        setFilterDisplay: setFilterDisplay
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            Collapse ? /*#__PURE__*/ _jsxs("fieldset", {
                                                disabled: formdisabled,
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagsInput, {
                                                                            value: tagselected,
                                                                            onChange: setTagSelected,
                                                                            name: "tag",
                                                                            placeHolder: ""
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !Collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: Collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs("fieldset", {
                                                disabled: formdisabled,
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: attachments.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "".concat(item.docUrl),
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "docfile",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "icon ".concat(item.docFileType)
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "name fs-18",
                                                                                            children: item.docFile
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 gap-3 d-flex ",
                                    children: [
                                        isReadyToPrint(formdisabled, values.dimMstNewStatus ? values.dimMstNewStatus.id : 0) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(GRPrint, {
                                                            innerRef: componentRef,
                                                            values: values,
                                                            isOnlyRecieve: false
                                                        }),
                                                        /*#__PURE__*/ _jsx(GRPrint, {
                                                            innerRef: componentOnlyReceiveRef,
                                                            values: values,
                                                            isOnlyRecieve: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Dropdown.Toggle, {
                                                            className: "btn btn-st-8 fs-14  px-4",
                                                            id: "dropdown-basic",
                                                            style: {
                                                                backgroundColor: "#2192FF",
                                                                borderColor: "#2192FF",
                                                                height: "40px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx("i", {
                                                                    className: "iprinter"
                                                                }),
                                                                "พิมพ์เอกสาร"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-8 fs-14 border-0 px-3 me-3 w-100",
                                                                    onClick: handlePrint,
                                                                    style: {
                                                                        backgroundColor: "#2192FF",
                                                                        borderColor: "#2192FF"
                                                                    },
                                                                    children: "พิมพ์ทั้งหมด"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-8 fs-14 border-0 px-3 me-3 w-100",
                                                                    onClick: handleOnlyReceivePrint,
                                                                    style: {
                                                                        backgroundColor: "#2192FF",
                                                                        borderColor: "#2192FF"
                                                                    },
                                                                    children: "พิมพ์เฉพาะที่รับ"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                                            className: "btn btn-st-8 fs-14  px-4",
                                                            id: "dropdown-basic",
                                                            style: {
                                                                backgroundColor: "#565DFF",
                                                                borderColor: "#565DFF",
                                                                height: "40px"
                                                            },
                                                            children: "ตัวเลือก"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100 ",
                                                                    children: "คัดลอกเอกสาร"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100",
                                                                    children: "ยกเลิกเอกสาร"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/goods-receipt");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ย้อนกลับ"
                                        }),
                                        caseController.isEdit && /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                setModalConfirmCancel(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true
                                                    });
                                                });
                                            },
                                            className: "bg-[#DC0000] text-white border-[#DC0000] me-3 px-4 btn ",
                                            disabled: isFinanVerify({
                                                dimMstFinancialStatus: {
                                                    id: values.financialStatusID
                                                }
                                            }) || ((_values_dimMstNewStatus1 = values.dimMstNewStatus) === null || _values_dimMstNewStatus1 === void 0 ? void 0 : _values_dimMstNewStatus1.id) === 7,
                                            children: "ยกเลิก"
                                        }),
                                        caseController.isCreate && /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            className: "bg-[#565DFF] text-white  btn ",
                                            onClick: function(e) {
                                                var isInValid = grVerifyCases(productRow, sumProductBalanceQuantity);
                                                if (isInValid.qtyNotMatch || isInValid.inputInvalid) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setAlert(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            QtyNotMatch: isInValid.qtyNotMatch,
                                                            InputInvalid: isInValid.inputInvalid
                                                        });
                                                    });
                                                    setModalVerifyInformation(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true
                                                        });
                                                    });
                                                }
                                            },
                                            children: "อนุมัติ และ บันทึก"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-[40px]"
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalConfirmCancel,
                                setModal: setModalConfirmCancel,
                                htitle: "ยืนยันการยกเลิก",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "เหตุผลการยกเลิก ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-danger",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    as: "textarea",
                                                    rows: 5,
                                                    name: "not_approve_reason",
                                                    onChange: handleChange,
                                                    isInvalid: !values.not_approve_reason,
                                                    value: values.not_approve_reason
                                                })
                                            ]
                                        }),
                                        values.is_update_stock && /*#__PURE__*/ _jsx("div", {
                                            className: "flex justify-end mt-5",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "px-3 py-2 rounded-lg text-xs text-[#DC0000] bg-[#FF0000]/[0.12]",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ _jsx(InfoOutlinedIcon, {}),
                                                    " การยกเลิกมีผลต่อจำนวนสินค้าคงคลัง"
                                                ]
                                            })
                                        }),
                                        !values.is_update_stock && /*#__PURE__*/ _jsx("div", {
                                            className: "flex justify-end mt-5",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "px-3 py-2 rounded-lg text-xs text-[#72e128de] bg-[#eefbe5]/[0.5]",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ _jsx(InfoOutlinedIcon, {}),
                                                    " การยกเลิกไม่มีผลต่อจำนวนสินค้าคงคลัง"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center pb-4 pt-4 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 ms-auto me-3 btn",
                                                    onClick: function() {
                                                        return setModalConfirmCancel(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function(e) {
                                                        // e.preventDefault();
                                                        setFieldValue("dim_mst_new_status_id", 7);
                                                    },
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(ModalAllder, {
                                modal: modalVerifyInformation,
                                setModal: setModalVerifyInformation,
                                htitle: "ตัวช่วยในการตรวจสอบข้อมูล",
                                hbtn: false,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "px-3 h-[300px] ",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-right text-lg mb-3  text-[#2F4858]",
                                                children: "ยืนยัน"
                                            }),
                                            alert.QtyNotMatch ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center ",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "text-lg text-[#2F4858] mr-auto",
                                                                children: "คุณยังรับสินค้าไม่ครบจำนวนตาม PO"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Checkbox, {
                                                                onChange: function(e) {
                                                                    if (e.target.checked) {
                                                                        setAlert(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                QtyNotMatchAccept: true
                                                                            });
                                                                        });
                                                                    } else {
                                                                        setAlert(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                QtyNotMatchAccept: false
                                                                            });
                                                                        });
                                                                    }
                                                                },
                                                                sx: {
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 30
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {})
                                                ]
                                            }) : "",
                                            alert.InputInvalid ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex mt-4 items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "text-lg text-[#2F4858] mr-auto",
                                                                children: "คุณยังไม่ได้ใส่เลขที่ LOT และวันที่หมดอายุ"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Checkbox, {
                                                                onChange: function(e) {
                                                                    if (e.target.checked) {
                                                                        setAlert(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                InputInvalidAccept: true
                                                                            });
                                                                        });
                                                                    } else {
                                                                        setAlert(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                InputInvalidAccept: false
                                                                            });
                                                                        });
                                                                    }
                                                                },
                                                                sx: {
                                                                    "& .MuiSvgIcon-root": {
                                                                        fontSize: 30
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {})
                                                ]
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-center ",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-6 me-3 text-[16px]",
                                                onClick: function() {
                                                    return setModalVerifyInformation(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: false
                                                        });
                                                    });
                                                },
                                                children: "ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "submit",
                                                className: "btn btn-st-3 me-3 text-[16px]",
                                                disabled: alert.QtyNotMatch && !alert.QtyNotMatchAccept || alert.InputInvalid && !alert.InputInvalidAccept,
                                                children: "บันทึก"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveRequestSuccess,
                setModal: setModalApproveRequestSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "ส่งคำขออนุมัติสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveSuccess,
                setModal: setModalApproveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-3",
                        style: {
                            fontSize: "22px",
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "คุณอนุมัติใบขอซื้อ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-3",
                        style: {
                            fontSize: "22px",
                            color: "#565DFF"
                        },
                        children: "เลขที่ PR-2410000001"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-2 fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#636578"
                        },
                        children: "สำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการรับสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalProductReceive, {
                action: action,
                modalProductReceive: modalProductReceive,
                setModalProductReceive: setModalProductReceive,
                productReceive: productReceive,
                setProductRow: setProductRow
            })
        ]
    });
}
function ProductData(_param) {
    var values = _param.values, setFieldValue = _param.setFieldValue, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionNewItemPrCol = _param.optionNewItemPrCol, productRow = _param.productRow, setProductRow = _param.setProductRow, sumproductPrice = _param.sumproductPrice, setSumproductPrice = _param.setSumproductPrice, sumproductNoVat = _param.sumproductNoVat, setSumproductNoVat = _param.setSumproductNoVat, sumproductZeroVat = _param.sumproductZeroVat, setSumproductZeroVat = _param.setSumproductZeroVat, sumproductSevenVat = _param.sumproductSevenVat, setSumproductSevenVat = _param.setSumproductSevenVat, sumproductBeforeVat = _param.sumproductBeforeVat, setSumproductBeforeVat = _param.setSumproductBeforeVat, sumProductReceiveQuantity = _param.sumProductReceiveQuantity, setSumProductReceiveQuantity = _param.setSumProductReceiveQuantity, columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, setFormdata = _param.setFormdata, setPdata = _param.setPdata, formdisabled = _param.formdisabled, setProductReceive = _param.setProductReceive, setModalProductReceive = _param.setModalProductReceive, sumProductReceivedQuantity = _param.sumProductReceivedQuantity, setSumProductReceivedQuantity = _param.setSumProductReceivedQuantity, sumProductBalanceQuantity = _param.sumProductBalanceQuantity, setSumProductBalanceQuantity = _param.setSumProductBalanceQuantity, caseController = _param.caseController, filterDisplay = _param.filterDisplay, setFilterDisplay = _param.setFilterDisplay, props = _object_without_properties(_param, [
        "values",
        "setFieldValue",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionNewItemPrCol",
        "productRow",
        "setProductRow",
        "sumproductPrice",
        "setSumproductPrice",
        "sumproductNoVat",
        "setSumproductNoVat",
        "sumproductZeroVat",
        "setSumproductZeroVat",
        "sumproductSevenVat",
        "setSumproductSevenVat",
        "sumproductBeforeVat",
        "setSumproductBeforeVat",
        "sumProductReceiveQuantity",
        "setSumProductReceiveQuantity",
        "columnsort",
        "setColumnsort",
        "setFormdata",
        "setPdata",
        "formdisabled",
        "setProductReceive",
        "setModalProductReceive",
        "sumProductReceivedQuantity",
        "setSumProductReceivedQuantity",
        "sumProductBalanceQuantity",
        "setSumProductBalanceQuantity",
        "caseController",
        "filterDisplay",
        "setFilterDisplay"
    ]);
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    getProductInit()
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    // useEffect(() => {
    //   if (productRow.length <= 0) {
    //     addProductRow(4);
    //   }
    // }, []);
    useEffect(function() {
        if (values.is_one_receiving_point && productRow.length > 0) {
            setProductRow(function(prev) {
                return prev.map(function(pd) {
                    if (pd.productID) {
                        var warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        var warehouseName = warehouse ? warehouse.label : "";
                        return _object_spread_props(_object_spread({}, pd), {
                            warehouseID: warehouseID,
                            warehouseName: warehouseName
                        });
                    }
                    return _object_spread({}, pd);
                });
            });
        }
    }, [
        values.dim_warehouse_id
    ]);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumProductOrderQuantity = _useState1[0], setSumProductOrderQuantity = _useState1[1];
    var sumQty = function(productRow) {
        var productOrderQuantity = 0;
        var productReceivedQuantity = 0;
        var productReceiveQuantity = 0;
        var productBalanceQuantity = 0;
        productRow.forEach(function(pd) {
            var productOrderQty = parseFloat(pd.productOrderQuantity);
            var productReceivedQty = parseFloat(pd.productReceivedQuantity);
            var productReceiveQty = parseFloat(pd.productReceiveQuantity);
            var hasValidproductOrderQty = productOrderQty > 0;
            var hasValidproductReceivedQty = productReceivedQty > 0;
            var hasValidproductReceiveQty = productReceiveQty > 0;
            if (hasValidproductOrderQty) {
                productOrderQuantity += productOrderQty;
            }
            if (hasValidproductReceivedQty) {
                productReceivedQuantity += productReceivedQty;
            }
            if (hasValidproductReceiveQty) {
                productReceiveQuantity += productReceiveQty;
            }
            if (caseController.isCreate) {
                productBalanceQuantity = productOrderQuantity - (productReceivedQuantity + productReceiveQuantity);
            }
            if (caseController.isEdit) {
                productBalanceQuantity = productOrderQuantity - productReceivedQuantity;
            }
        });
        setSumProductReceivedQuantity(productReceivedQuantity);
        setSumProductOrderQuantity(productOrderQuantity);
        setSumProductReceiveQuantity(productReceiveQuantity);
        setSumProductBalanceQuantity(productBalanceQuantity);
    };
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _useState2 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "gr-product-select"
    }), 2), modal = _useState2[0], setModal = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "gr-product-sort"
    }), 2), modalSort = _useState3[0], setModalSort = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "gr-product-display"
    }), 2), modalDisplayColumn = _useState4[0], setModalDisplayColumn = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "gr-product-filter"
    }), 2), modalDisplayFilter = _useState5[0], setModalDisplayFilter = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), documentType = _useState6[0], setDocumentType = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 670,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState7[0], setModalLoadDocument = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "pr-select-document"
    }), 2), modalSelectDocument = _useState8[0], setModalSelectDocument = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false
    }), 2), columdisplay = _useState9[0], setColumDisplay = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), historyProduct = _useState10[0], setHistoryProduct = _useState10[1];
    var _useState11 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-history"
    }), 2), modalProductHistory = _useState11[0], setModalProductHistory = _useState11[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columGRdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState12 = _sliced_to_array(useState(false), 2), customSort = _useState12[0], setCustomSort = _useState12[1];
    var _useState13 = _sliced_to_array(useState(), 2), activeId = _useState13[0], setActiveId = _useState13[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    var checkProductReceived = productRow.filter(function(prev) {
        return prev.productReceivedQuantity > 0;
    });
    // productRow
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    productRow: productRow,
                    setProductRow: setProductRow,
                    addProductRow: addProductRow,
                    optionsWarehouse: optionsWarehouse,
                    optionsMstVat: optionsMstVat,
                    values: values
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemPrCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "dim_new_item_pr_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล GR",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    columdisplayName: "columGRdisplay",
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalLoadDocument,
                setModal: setModalLoadDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(LoadDocument, {
                    columdisplay: columdisplay,
                    setModal: setModalLoadDocument,
                    setDocumentType: setDocumentType,
                    setModalSelectDocument: setModalSelectDocument,
                    setProductRow: setProductRow,
                    setFormdata: setFormdata,
                    setPdata: setPdata
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProductHistory,
                setModal: setModalProductHistory,
                htitle: "ดูประวัติสินค้า",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductHistory, {
                    historyProduct: historyProduct,
                    setModalProductHistory: setModalProductHistory
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayFilter,
                setModal: setModalDisplayFilter,
                htitle: "ตัวกรอง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableFilterDisplay, {
                    filterDisplay: filterDisplay,
                    filterdisplayName: "filterdisplay",
                    setModalDisplayFilter: setModalDisplayFilter,
                    setFilterDisplay: setFilterDisplay
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            type: "button",
                            onClick: function() {
                                setHistoryProduct(checkLength);
                                setModalProductHistory(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: checkLength.length != 1,
                            children: "ดูประวัติสินค้า"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                setProductRow(function(productRow) {
                                    return productRow.filter(function(item) {
                                        return item.is_checked !== true;
                                    });
                                });
                                addProductRow(checkLenght);
                            },
                            disabled: caseController.isEdit || caseController.isCreate,
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : customSort ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "alert-w",
                            children: "กรุณาเลือกที่แถวเพื่อจัดลำดับ"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            className: "btn btn-st-x1 me-2",
                            children: "บันทึกการจัดเรียง"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            children: "ยกเลิกการจัดเรียง"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 flex",
                    children: [
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: formdisabled,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-x1 me-2",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: true
                                        });
                                    });
                                },
                                disabled: true,
                                children: "เพิ่มหลายรายการ"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalSort(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: true,
                            children: "จัดเรียง"
                        }),
                        /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        return setModalLoadDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    disabled: true,
                                    children: "โหลดเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                            setFormdata: setFormdata,
                                            setProductRow: setProductRow,
                                            setPdata: setPdata,
                                            setModal: setModalSelectDocument
                                        }));
                                        setModalSelectDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    disabled: true,
                                    children: "โหลดใบขอซื้อ"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                    // setDocumentType(<LoadPR setModal={setModalSelectDocument} />);
                                    // setModalSelectDocument((prev) => ({ ...prev, open: true }));
                                    },
                                    disabled: true,
                                    children: "โหลดใบสั่งขาย"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                    // setDocumentType(<LoadPR setModal={setModalSelectDocument} />);
                                    // setModalSelectDocument((prev) => ({ ...prev, open: true }));
                                    },
                                    disabled: true,
                                    children: "โหลดใบสั่งซื้อ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setModalDisplayColumn(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: false,
                            children: "ตัวเลือกแสดงผล"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalDisplayFilter(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ตัวกรอง"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("fieldset", {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pagezoom",
                    style: {
                        overflowX: "auto",
                        maxWidth: "100%",
                        overflowY: "hidden",
                        paddingBottom: "20px"
                    },
                    children: /*#__PURE__*/ _jsx(DndContext, {
                        sensors: sensors,
                        collisionDetection: closestCenter,
                        onDragEnd: handleDragEnd,
                        onDragCancel: handleDragCancel,
                        onDragStart: handleDragStart,
                        modifiers: [
                            restrictToVerticalAxis
                        ],
                        children: /*#__PURE__*/ _jsx(SortableContext, {
                            items: productRow,
                            strategy: verticalListSortingStrategy,
                            children: /*#__PURE__*/ _jsxs("table", {
                                className: "column_resize_table table1 table-striped ",
                                style: {
                                    width: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("thead", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "form-check form-check-st-t1",
                                                        children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                            className: "form-check-input",
                                                            type: "checkbox",
                                                            name: "",
                                                            onChange: function(e) {
                                                                if (e.target.checked === true) {
                                                                    setProductRow(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return _object_spread_props(_object_spread({}, el), {
                                                                                is_checked: true
                                                                            });
                                                                        });
                                                                    });
                                                                } else {
                                                                    setProductRow(function(prev) {
                                                                        return prev.map(function(el) {
                                                                            return _object_spread_props(_object_spread({}, el), {
                                                                                is_checked: false
                                                                            });
                                                                        });
                                                                    });
                                                                }
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 35
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รหัสสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    defaultWidth: 200,
                                                    minWidth: 5
                                                }),
                                                columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "บาร์โค้ด"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                }) : "",
                                                columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รหัสสินค้าผู้ขาย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 130
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รายการ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 450
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "หน่วย"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "!bg-[#666CFF] !text-[#FFF]",
                                                    children: "จำนวนที่สั่ง"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer !bg-[#666CFF] !text-[#FFF]",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                }),
                                                checkProductReceived.length > 0 && caseController.isCreate ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            className: "!bg-[#909090]  !text-[#FFF]",
                                                            children: "จำนวนที่รับแล้ว"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer !bg-[#909090] !text-white",
                                                            minWidth: 5,
                                                            defaultWidth: 140
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "!bg-[#FF731D] !text-[#FFF] ",
                                                    children: "จำนวนรับครั้งนี้"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer !bg-[#FF731D] !text-[#FFF] ",
                                                    minWidth: 5,
                                                    defaultWidth: 110
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "!bg-[#909090]  !text-[#FFF]",
                                                    children: "จำนวนค้างรับ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer !bg-[#909090] !text-white",
                                                    minWidth: 5,
                                                    defaultWidth: 140
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "จัดการ LOT"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 120
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "หมายเหตุ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tbody", {
                                        children: productRow.map(function(item, index) {
                                            var _filterDisplay_onlyReceiveProduct;
                                            if (!(filterDisplay === null || filterDisplay === void 0 ? void 0 : (_filterDisplay_onlyReceiveProduct = filterDisplay.onlyReceiveProduct) === null || _filterDisplay_onlyReceiveProduct === void 0 ? void 0 : _filterDisplay_onlyReceiveProduct.isActive) || item.productReceiveQuantity > 0) {
                                                return /*#__PURE__*/ _jsx(Productrow, {
                                                    item: item,
                                                    index: index,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    rowCount: rowCount,
                                                    values: values,
                                                    setProductRow: setProductRow,
                                                    setProductReceive: setProductReceive,
                                                    setModalProductReceive: setModalProductReceive,
                                                    checkProductReceived: checkProductReceived,
                                                    caseController: caseController
                                                }, index);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tfoot", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "sumProductOrderQuantity",
                                                        className: "form-control text-center disabled:bg-[#EDEDFF] text-[#666CFF]",
                                                        placeholder: "",
                                                        value: sumProductOrderQuantity,
                                                        disabled: true,
                                                        style: {
                                                            position: "absolute",
                                                            right: "-0.5vw",
                                                            top: "10px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                checkProductReceived.length > 0 && caseController.isCreate ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "sumProductReceiveQuantity",
                                                                className: "form-control text-center disabled:bg-[#FFFFFF] text-[#061126]",
                                                                placeholder: "",
                                                                value: sumProductReceivedQuantity,
                                                                disabled: true,
                                                                style: {
                                                                    position: "absolute",
                                                                    right: "-0.5vw",
                                                                    top: "10px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "sumProductReceiveQuantity",
                                                        className: "form-control text-center disabled:bg-[#FFEDE0] text-[#FF6B00]",
                                                        placeholder: "",
                                                        value: sumProductReceiveQuantity,
                                                        disabled: true,
                                                        style: {
                                                            position: "absolute",
                                                            right: "-0.5vw",
                                                            top: "10px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body "
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "sumproductBalanceQuantity",
                                                        className: "form-control text-center disabled:bg-[#FFFFFF] text-[#FF0000]",
                                                        placeholder: "",
                                                        value: sumProductBalanceQuantity,
                                                        disabled: true,
                                                        style: {
                                                            position: "absolute",
                                                            right: "-0.5vw",
                                                            top: "10px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, dataID = _param.dataID, setProductReceive = _param.setProductReceive, setModalProductReceive = _param.setModalProductReceive, checkProductReceived = _param.checkProductReceived, caseController = _param.caseController, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "dataID",
        "setProductReceive",
        "setModalProductReceive",
        "checkProductReceived",
        "caseController"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                style: customSort ? {
                    paddingLeft: 0
                } : {},
                children: customSort ? /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                    style: {
                        paddingLeft: "14px",
                        transform: CSS.Transform.toString(transform),
                        transition: transition
                    },
                    ref: setNodeRef
                }, attributes, listeners), {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "btn-drag"
                    })
                })) : /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start ",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mr-1",
                            children: [
                                index + 1,
                                ". "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "form-check form-check-st-t1",
                            children: /*#__PURE__*/ _jsx("input", {
                                className: "form-check-input",
                                type: "checkbox",
                                name: "",
                                checked: item.is_checked,
                                onChange: function(e) {
                                    if (e.target.checked === true) {
                                        setProductRow(function(prev) {
                                            return prev.map(function(el) {
                                                if (el.rowID === item.rowID) {
                                                    return _object_spread_props(_object_spread({}, el), {
                                                        is_checked: true
                                                    });
                                                }
                                                return el;
                                            });
                                        });
                                    } else {
                                        setProductRow(function(prev) {
                                            return prev.map(function(el) {
                                                if (el.rowID === item.rowID) {
                                                    return _object_spread_props(_object_spread({}, el), {
                                                        is_checked: false
                                                    });
                                                }
                                                return el;
                                            });
                                        });
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productCode
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productBarcode
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("td", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-15",
                                children: item.supplierCode
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            item.supplierName
                        ]
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                className: "!text-left",
                children: item.productName
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: !!item.productUnit && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        item.productUnit,
                        /*#__PURE__*/ _jsx("br", {}),
                        "1X",
                        item.productRatioUnit
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF] !text-[#666CFF]",
                children: item.productOrderQuantity
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF] !text-[#666CFF]"
            }),
            checkProductReceived.length > 0 && caseController.isCreate ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: " !text-[#061126]",
                        children: item.productReceivedQuantity
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body  !text-[#061126]"
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsxs("td", {
                className: "!bg-[#FFEDE0] !text-[#FF731D]",
                children: [
                    caseController.isCreate && /*#__PURE__*/ _jsx("input", {
                        type: "number",
                        className: "form-control formv text-center border-0 me-2",
                        value: item.productReceiveQuantity,
                        onFocus: function(e) {
                            return e.target.select();
                        },
                        onWheel: function(e) {
                            return e.target.blur();
                        },
                        onChange: function(e) {
                            var inputValue = parseInt(e.target.value) || 0;
                            var max = item.productOrderQuantity - item.productReceivedQuantity;
                            var validatedValue = inputValue < 1 ? 0 : Math.min(inputValue, max);
                            setProductRow(function(prev) {
                                return prev.map(function(el) {
                                    if (el.rowID === item.rowID) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            productReceiveQuantity: validatedValue
                                        });
                                    }
                                    return el;
                                });
                            });
                        }
                    }),
                    caseController.isEdit && /*#__PURE__*/ _jsx(_Fragment, {
                        children: item.productReceiveQuantity
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#FFEDE0] !text-[#FF731D]"
            }),
            /*#__PURE__*/ _jsxs("td", {
                className: " !text-[#DC0000]",
                children: [
                    caseController.isCreate && /*#__PURE__*/ _jsx(_Fragment, {
                        children: item.productOrderQuantity - (item.productReceivedQuantity + item.productReceiveQuantity)
                    }),
                    caseController.isEdit && /*#__PURE__*/ _jsx(_Fragment, {
                        children: item.productOrderQuantity - item.productReceivedQuantity
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body  !text-[#DC0000]"
            }),
            /*#__PURE__*/ _jsxs("td", {
                children: [
                    caseController.isCreate && !item.receivelist && /*#__PURE__*/ _jsxs(Button, {
                        className: "!bg-transparent !text-[#080808] hover:!text-[#666CFF] hover:!bg-transparent  border-0 flex items-center",
                        onClick: function() {
                            setProductReceive(item);
                            setModalProductReceive(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: true
                                });
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon-pencil h-[24px] w-[24px] block rounded-full  bg-[#666CFF] mr-2"
                            }),
                            " ",
                            "จัดการ"
                        ]
                    }),
                    (caseController.isEdit || item.receivelist) && /*#__PURE__*/ _jsxs(Button, {
                        className: "!bg-transparent !text-[#080808] hover:!text-[#FF731D] hover:!bg-transparent  border-0 flex items-center",
                        onClick: function() {
                            setProductReceive(item);
                            setModalProductReceive(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: true
                                });
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon-pencil h-[24px] w-[24px] block rounded-full  bg-[#FF731D] mr-2"
                            }),
                            " ",
                            "แก้ไข"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.note
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
function Steps(_param) {
    var grstatus = _param.grstatus, props = _object_without_properties(_param, [
        "grstatus"
    ]);
    var steps = [
        "ใบรับสินค้า",
        "เสร็จสิ้น"
    ];
    var mappingStatus = function(grstatus) {
        var index = 0;
        switch(grstatus){
            case 7:
                index = 1;
                break;
            case 6:
                index = 2;
                break;
            default:
                index = 0;
                break;
        }
        return index;
    };
    var _useState = _sliced_to_array(useState(mappingStatus(grstatus)), 2), activeStep = _useState[0], setActiveStep = _useState[1];
    useEffect(function() {
        setActiveStep(mappingStatus(grstatus));
    }, [
        grstatus
    ]);
    return /*#__PURE__*/ _jsx(Stepper, {
        activeStep: activeStep,
        alternativeLabel: true,
        children: steps.map(function(label, index) {
            var stepProps = {};
            var labelProps = {};
            return /*#__PURE__*/ _jsx(Step, _object_spread_props(_object_spread({}, stepProps), {
                children: /*#__PURE__*/ _jsx(StepLabel, _object_spread_props(_object_spread({}, labelProps), {
                    style: {
                        fontSize: "16px"
                    },
                    children: label
                }))
            }), label);
        })
    });
}
